





































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SitePermission } from '@/models/site-permission';
import { CreateUserRequest } from '@/models/create-user-request';
import { User } from '@/models/user';
import { namespace } from 'vuex-class';
import { UserCustomer } from '@/models/user-customer';
import { UserRole } from '@/models/user-role';
import { Customer } from '@/models/customer';
import { CustomerApi } from '@/api/customer-api';
import { UserSite } from '@/models/user-site';

const userModule = namespace('user');
const customerApi = new CustomerApi();
@Component
export default class EditPermissionsModal extends Vue {
    @userModule.Getter('user') public currentUser: User;
    @userModule.Getter('userIsSystem') public userIsSystem: (user: User) => boolean;
    @Prop({ required: true, type: Boolean }) public show: boolean;
    @Prop({ required: true }) public user: User;
    public allCustomers: Array<{ id: string, name: string, sites: Array<{ id: string, name: string, customerId: string, permissions: Array<{ id: string, name: string, selected: boolean }>, selected: boolean }>, selected: boolean }> = [];
    public showing: boolean = this.show;
    public customersToGrant: Array<{ id: string }> = new Array<{ id: string }>();
    public customersToRevoke: Array<{ id: string }> = new Array<{ id: string }>();
    public sitesToGrant: Array<{ id: string, customerId: string }> = new Array<{ id: string, customerId: string }>();
    public sitesToRevoke: Array<{ id: string, customerId: string }> = new Array<{ id: string, customerId: string }>();
    public permissionsToGrant: Array<{ id: string, customerId: string, siteId: string }> = new Array<{ id: string, customerId: string, siteId: string }>();
    public permissionsToRevoke: Array<{ id: string, siteId: string, customerId: string }> = new Array<{ id: string, siteId: string, customerId: string }>();

    public get userSites(): Array<UserSite> {
        let sites = new Array<UserSite>();
        for (const customer of this.user.customers) {
            sites = sites.concat(customer.sites);
        }
        return sites;
    }
    public get userSitePermissions(): Array<SitePermission> {
        let permissions = new Array<SitePermission>();
        for (const site of this.userSites) {
            permissions = permissions.concat(site.permissions);
        }
        return permissions;
    }
    public get selectedCustomers(): Array<{ id: string, name: string, sites: Array<{ id: string, name: string, customerId: string, permissions: Array<{ id: string, name: string, selected: boolean }>, selected: boolean }>, selected: boolean }> {
        return this.allCustomers.filter((c) => c.selected);
    }
    public get selectedSites(): Array<{ id: string, name: string, customerId: string, permissions: Array<{ id: string, name: string, selected: boolean }>, selected: boolean }> {
        let sites = new Array<{ id: string, name: string, customerId: string, permissions: Array<{ id: string, name: string, selected: boolean }>, selected: boolean }>();
        for (const customer of this.selectedCustomers) {
            sites = sites.concat(customer.sites.filter((s) => s.selected));
        }
        return sites;
    }
    public customerNameFromCustomerId(customerId: string): string | null {
        return this.allCustomers.find((c) => c.id === customerId)?.name || null;
    }
    public onCustomerSelectionChanged(customer: { id: string, selected: boolean }): void {
        const grantIndex = this.customersToGrant.findIndex((c) => c.id === customer.id);
        const revokeIndex = this.customersToRevoke.findIndex((c) => c.id === customer.id);

        // If deselecting a customer that is in customersToGrant
        if (!customer.selected && grantIndex > -1) {
            this.customersToGrant.splice(grantIndex, 1);
        }
        // If selecting a customer that is in customersToRevoke
        if (customer.selected && revokeIndex > -1) {
            this.customersToRevoke.splice(revokeIndex, 1);
        }

        const userCustomerIndex = this.user.customers.findIndex((c) => c.customerId === customer.id);
        // If deselecting a customer that the user already has access to
        if (!customer.selected && userCustomerIndex > -1) {
            this.customersToRevoke.push(customer);
        }
        // If selecting a customer that the user doesn't already have access to
        if (customer.selected && userCustomerIndex === -1) {
            this.customersToGrant.push(customer);
        }
    }
    public onSiteSelectionChanged(site: { id: string, customerId: string, selected: boolean }): void {
        const grantIndex = this.sitesToGrant.findIndex((s) => s.id === site.id);
        const revokeIndex = this.sitesToRevoke.findIndex((s) => s.id === site.id);

        // If deselecting a site that is in sitesToGrant
        if (!site.selected && grantIndex > -1) {
            this.sitesToGrant.splice(grantIndex, 1);
        }
        // If selecting a site that is in sitesToRevoke
        if (site.selected && revokeIndex > -1) {
            this.sitesToRevoke.splice(revokeIndex, 1);
        }

        const userSiteIndex = this.userSites.findIndex((s) => s.siteId === site.id);
        // If deselecting a site that the user already has access to
        if (!site.selected && userSiteIndex > -1) {
            this.sitesToRevoke.push(site);
        }
        // If selecting a site that the user doesn't already have access to
        if (site.selected && userSiteIndex === -1) {
            this.sitesToGrant.push(site);
        }
    }
    public onPermissionSelectionChanged(permission: { id: string, selected: boolean }, siteId: string, customerId: string): void {
        const grantIndex = this.permissionsToGrant.findIndex((p) => p.id === permission.id && p.siteId === siteId && p.customerId === customerId);
        const revokeIndex = this.permissionsToRevoke.findIndex((p) => p.id === permission.id && p.siteId === siteId && p.customerId === customerId);

        // If deselecting a permission that is in permissionsToGrant
        if (!permission.selected && grantIndex > -1) {
            this.permissionsToGrant.splice(grantIndex, 1);
        }
        // If selecting a permission that is in permissionsToRevoke
        if (permission.selected && revokeIndex > -1) {
            this.permissionsToRevoke.splice(revokeIndex, 1);
        }

        const userPermissionIndex = this.userSitePermissions.findIndex((p) => p.permissionId === permission.id && p.siteId === siteId && p.customerId === customerId);
        // If deselecting a permission that the user already has access to
        if (!permission.selected && userPermissionIndex > -1) {
            this.permissionsToRevoke.push({ id: permission.id, siteId: siteId, customerId: customerId });
        }
        // If selecting a permission that the user doesn't already have access to
        if (permission.selected && userPermissionIndex === -1) {
            this.permissionsToGrant.push({ id: permission.id, siteId: siteId, customerId: customerId });
        }
    }
    public sitePermissions(): Array<{ id: string, name: string, selected: boolean }> {
        const all = new Array<{ id: string, name: string, selected: boolean }>(...[
            { id: 'a8dec754-9a53-4037-ba03-ebc3b3fc1951', name: 'Create enquiries', selected: false },
            { id: '06e41f0c-6058-469d-b53e-8710ac5b7c77', name: 'View enquiries', selected: false },
            { id: '2548ca69-d42c-4b2a-8fdb-6906e79f3b11', name: 'Create orders', selected: false },
            { id: '46befeae-387e-4f1e-a2b3-6034df1286eb', name: 'View orders', selected: false },
            { id: '2e5e95a6-361e-4bbf-968c-c766ab782ee8', name: 'Create quotes', selected: false },
            { id: '8a3a0700-01bd-4788-b1bb-d3ed58f79c95', name: 'View quotes', selected: false },
            { id: '312b9feb-f26f-40f7-bf93-34c664aae57a', name: 'View Approvals', selected: false },
            { id: 'a8ab1446-1848-48e7-9e7f-dbaa01bd6a90', name: 'Approve up to £1,000', selected: false },
            { id: '2f6f468d-f5e3-43db-8897-f4fe747a4a30', name: 'Approve from £1,000 to £5,000', selected: false },
            { id: 'e003b0be-fd26-452a-bf0f-a071608f5831', name: 'Approve from £5,000 to £10,000', selected: false },
            { id: 'dd0b632e-b592-49d5-aebc-0bf222e061fe', name: 'Approve from £10,000 upwards', selected: false }
        ]);

        return all;
    }
    // Note(Seb): Populate the matrix with the user's customers, sites and permissions
    public populateCustomersSitesAndPermissions(): void {
        for (const customer of this.allCustomers) {
            const customerMatch = this.user.customers.find((c) => c.customerId === customer.id) || null;

            if (customerMatch !== null) {
                customer.selected = true;

                for (const site of customer.sites) {
                    const siteMatch = customerMatch.sites.find((s) => s.siteId === site.id) || null;

                    if (siteMatch !== null) {
                        site.selected = true;

                        for (const permission of site.permissions) {
                            const permissionMatch = siteMatch.permissions.find((p) => p.permissionId === permission.id) || null;

                            if (permissionMatch !== null) {
                                permission.selected = true;
                            }
                        }
                    }
                }
            }
        }
    }
    public save(): void {
        this.$emit('user-permissions-saved', this.customersToGrant, this.customersToRevoke, this.sitesToGrant, this.sitesToRevoke, this.permissionsToGrant, this.permissionsToRevoke);
    }
    public toggleShow(): void {
        if (this.showing) {
            this.$emit('user-permissions-show');
        } else {
            this.$emit('user-permissions-hide');
        }
    }
    @Watch('show')
    public toggle(value: boolean): void {
        this.showing = value;
    }
    public async mounted(): Promise<void> {
        const result = await customerApi.fetchAsync();
        this.allCustomers = result.customers.map((c) => ({
            id: c.id,
            name: c.name,
            sites: c.sites.map((s) => ({
                id: s.id,
                name: s.name,
                customerId: s.customerId,
                permissions: [ ...this.sitePermissions() ],
                selected: false,
            } as { id: string, name: string, customerId: string, permissions: Array<{ id: string, name: string, selected: boolean }>, selected: boolean })),
            selected: false,
        } as { id: string, name: string, sites: Array<{ id: string, name: string, customerId: string, permissions: Array<{ id: string, name: string, selected: boolean }>, selected: boolean }>, selected: boolean }));

        this.populateCustomersSitesAndPermissions();
    }
}
